import { parseCoordinate } from "@/utils/NumberUtils"
import { type AnalysisCompType } from "@/generated/graphql"

interface MapBounds {
  minLat: number
  maxLat: number
  minLon: number
  maxLon: number
}

export const calculateVisibleComps = (
  latitude: number,
  longitude: number,
  comps: AnalysisCompType[],
  zoom: number,
  mapWidth: number,
  mapHeight: number
): number => {
  if (latitude === null || longitude === null) {
    return 0 // Early return if primary coordinates are not valid
  }

  const { minLat, maxLat, minLon, maxLon } = estimateVisibleBounds(
    latitude,
    longitude,
    zoom,
    mapWidth,
    mapHeight
  )

  return comps.reduce((count, comp) => {
    const compLat = parseCoordinate(comp.arvcomp?.latitude)
    const compLon = parseCoordinate(comp.arvcomp?.longitude)
    if (compLat !== null && compLon !== null) {
      if (
        compLat >= minLat &&
        compLat <= maxLat &&
        compLon >= minLon &&
        compLon <= maxLon
      ) {
        return count + 1
      }
    }
    return count
  }, 0)
}

function estimateVisibleBounds(
  latitude: number,
  longitude: number,
  zoom: number,
  mapWidth: number,
  mapHeight: number
): MapBounds {
  const scale =
    (156543.03392 * Math.cos((latitude * Math.PI) / 180)) / Math.pow(2, zoom)
  const halfWidth = (scale * mapWidth) / 2
  const halfHeight = (scale * mapHeight) / 2

  return {
    minLat: latitude - halfHeight / 111320,
    maxLat: latitude + halfHeight / 111320,
    minLon:
      longitude - halfWidth / (111320 * Math.cos((latitude * Math.PI) / 180)),
    maxLon:
      longitude + halfWidth / (111320 * Math.cos((latitude * Math.PI) / 180)),
  }
}
